/**
 * AppClipboard bond setup
 *
 * Wires @molecule/app-clipboard-web to @molecule/app-clipboard (copy buttons
 * and copy-on-click commands on the landing and package pages).
 */

import { setProvider } from '@molecule/app-clipboard'
import { provider } from '@molecule/app-clipboard-web'

export function setupAppClipboardWeb(): void {
  setProvider(provider)
}
